const mutations = {
  SET_SUBSCRIPTION_PLANS (state, { subscription_plans }) {
    state.subscription_plans = subscription_plans
  },
  SET_PUBLISHED_SUBSCRIPTION_PLANS (state, { published_subscription_plans }) {
    state.published_subscription_plans = published_subscription_plans
  }
}

export default mutations
